var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from "nuxt-class-component";
import { Prop } from 'vue-property-decorator';
import { TsVue } from "~/plugins/TsVue";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showSlide = true;
        return _this;
    }
    Object.defineProperty(default_1.prototype, "slideWrapClass", {
        get: function () {
            var classnames = ['slide-wrap', { 'cd-slide-hide': this.showSlide }];
            switch (this.position) {
                case 'left':
                    classnames.push('slide-wrap-left');
                    break;
                case 'right':
                default:
                    classnames.push('slide-wrap-right');
            }
            return classnames;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(default_1.prototype, "slideBtn", {
        get: function () {
            var classnames = ['show-slide-btn'];
            switch (this.position) {
                case 'left':
                    classnames.push('slide-btn-left');
                    break;
                case 'right':
                default:
                    classnames.push('slide-btn-right');
            }
            return classnames;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Prop({
            type: String,
            default: 'right'
        })
    ], default_1.prototype, "position", void 0);
    default_1 = __decorate([
        Component({
            name: 'Slide',
            components: {}
        })
    ], default_1);
    return default_1;
}(TsVue));
export default default_1;



//////////////////
// WEBPACK FOOTER
// /opt/node_modules/ts-loader?{"appendTsSuffixTo":[{}],"transpileOnly":true}!/opt/node_modules/vue-loader/lib/selector.js?type=script&index=0!./public/slide/src/main.vue
// module id = NAyu
// module chunks = 28